import { Label } from 'react-aria-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Control, Controller, FieldPath, FieldValues, FieldError } from 'react-hook-form';

import { formattedDate } from '@/logics/date/date';

// 30分刻みの時間選択用のコンポーネントです

type Props<T extends FieldValues> = {
  name: FieldPath<T>;
  label?: string;
  control: Control<T>;
  required?: boolean;
  errors?: FieldError | undefined;
};

const TimeField = <T extends FieldValues>(props: Props<T>) => {
  return (
    <div className="relative w-full">
      {props.label && (
        <div className="flex flex-row items-center">
          <Label className="mb-2 text-base md:text-lg md:font-bold">{props.label}</Label>
          {props.required && (
            <span className="mb-2 ml-1 text-base text-red-800 md:text-sm">※必須</span>
          )}
        </div>
      )}
      <Controller
        name={props.name}
        control={props.control}
        rules={{ required: props.required }}
        render={({ field: { onChange, value } }) => {
          return (
            <DatePicker
              id="time"
              selected={getValidTime(value)}
              onChange={(date) => {
                if (date instanceof Date) {
                  onChange(formattedDate(date, 'HH:mm:ss'));
                } else {
                  onChange(null);
                }
              }}
              dateFormat="HH:mm"
              locale="ja"
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={30}
              timeCaption="時間"
              dropdownMode="select"
              placeholderText="00:00"
              className="mb-2 block h-10 w-full rounded-md border border-[#1A1A1A] px-3 py-2 focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm md:h-14"
              wrapperClassName="w-full"
              popperClassName="react-datepicker-popper"
              popperPlacement="bottom-start"
            />
          );
        }}
      />
      {props.errors && (
        <span className="mb-2 w-fit text-sm text-red-800">{props.errors.message}</span>
      )}
    </div>
  );
};

// HH:mm:ss形式の文字列、Date型、nullのいずれかを返す関数です
const getValidTime = (value: string | Date | null): Date | null => {
  if (!value) return null;

  if (value instanceof Date) {
    return value;
  }
  const [hour, minute] = value.split(':').map((v) => parseInt(v));
  const date = new Date();
  date.setHours(hour);
  date.setMinutes(minute);
  return date;
};

export default TimeField;
